module.exports = __webpack_public_path__ + "img/newswiper_4.cbf5fa32.png";